import React from "react";
import css from "./PanelHeader.module.css";

import arrowLeftSvg from "public/assets/svg/arrow-left.svg";

import cn from "classnames";
import { IconButton } from "../IconButton/IconButton";

type Props = {
    title: string | React.ReactNode;
    onBack?: () => void;
    noUnderline?: boolean;
};

export const PanelHeader: React.FC<Props> = ({ title, onBack, noUnderline }) => {
    return (
        <div className={cn(css.main, "typography-title", noUnderline && css.noUnderline)}>
            {onBack && <IconButton onClick={onBack} iconSrc={arrowLeftSvg} />}
            <div className={css.title}>{title}</div>
        </div>
    );
};
